import { getBaseDomainFromHostname } from './domainUtil';

export const getChatHostname = () => {
  const hostname = window.location.hostname;
  const baseDomain = getBaseDomainFromHostname(hostname, 'nmd.co');

  let chatHostName = baseDomain;
  let protocol = 'https';

  if (hostname === 'm.docker.named.com') {
    chatHostName = 'docker.named.com';
    protocol = 'http';
  } else if (hostname === 'localhost') {
    chatHostName = 'dev.nmd.co';
    protocol = 'http';
  } else if (hostname.startsWith('dev-m.')) {
    chatHostName = `dev.${baseDomain}`;
    protocol = 'http';
  }

  return {
    chatHostName,
    chatHostNameWithProtocol: `${protocol}://${chatHostName}/`,
  };
};

export const isNamedDomain = () => {
  const hostname = window.location.hostname;
  // Preserve legacy intent: treat known mobile hosts and localhost as "named domain".
  if (hostname === 'localhost') return true;
  return hostname.startsWith('m.') || hostname.startsWith('m-stage.') || hostname.startsWith('dev-m.');
};

export const getMobileHomeUrl = () => {
  const hostname = window.location.hostname;
  const baseDomain = getBaseDomainFromHostname(hostname, 'nmd.co');

  if (hostname.startsWith('dev-m.')) {
    return `http://dev-m.${baseDomain}`;
  }

  if (hostname.startsWith('m-stage.')) {
    return `https://m-stage.${baseDomain}`;
  }

  return `https://m.${baseDomain}`;
};
